/*
 * This component is responsible for rendering a modal.
 * It takes props to populate the body as well as the footer.
 *
 * @author Cargomatic Engineering
 * @usage <CargomaticModal />
 *
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
const CargomaticModal = (props) => {
    const { show, size, title, body, children, footer, onHide, showCloseButton, showHeader, titleClassNames, dialogClassName, 
    // location,
    backdrop, style, keyboard, enforceFocus, } = props;
    return (React.createElement("div", { "data-testid": "div-27731577" },
        React.createElement(Modal, { dialogClassName: dialogClassName, show: show, onHide: onHide, backdrop: backdrop, style: style, bsSize: size, keyboard: keyboard, enforceFocus: enforceFocus },
            showHeader && (React.createElement(Modal.Header, { "data-testid": "undefined-e6b5dffa", closeButton: showCloseButton },
                React.createElement(Modal.Title, { "data-testid": "undefined-b720de11", className: titleClassNames }, title))),
            React.createElement(Modal.Body, { "data-testid": "undefined-e4516bc5" }, body || children),
            footer && (React.createElement(Modal.Footer, { "data-testid": "undefined-e6ce3455" }, footer)))));
};
CargomaticModal.propTypes = {
    show: PropTypes.bool, // Show the modal
    onHide: PropTypes.func.isRequired, // onHide Callback
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]), // Modal Title
    showHeader: PropTypes.bool, // Show the header section
    style: PropTypes.object,
    body: PropTypes.node, // body component
    children: PropTypes.any,
    footer: PropTypes.node, // footer component
    showCloseButton: PropTypes.bool, // Show the close button?
    dialogClassName: PropTypes.string, // class override for modal width
    // location: PropTypes.string, // Location of the modal vertically
    titleClassNames: PropTypes.string,
    backdrop: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
    size: PropTypes.string,
    keyboard: PropTypes.bool,
};
CargomaticModal.defaultProps = {
    show: true,
    title: 'Cargomatic Modal',
    showHeader: true,
    showCloseButton: true,
    dialogClassName: '',
    // location: 'middle',
    titleClassNames: 'text-grey-darker',
    backdrop: true,
    keyboard: true,
    enforceFocus: false, // Allow interaction with Radix dialogs that render above this modal
};
export default CargomaticModal;
